import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { finalize } from 'rxjs';
import { AuthService } from '../shared/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-password-change',
  templateUrl: './password-change.component.html',
  styleUrls: ['./password-change.component.less']
})
export class PasswordChangeComponent {
	processingRequest: boolean = false;
	passwordChanged: boolean = false;

	readonly passwordChangeForm = new FormGroup({
		currentPassword: new FormControl<string>('', [Validators.required]),
		newPassword: new FormControl<string>('', [Validators.required])
	});

	constructor(
		private readonly _router: Router,
		private readonly _authService: AuthService
	) { }

	complete() {
		if (this._authService.returnUrl) {
			window.location.href = this._authService.returnUrl;
		}
		else {
			this._router.navigate(["/login"], { queryParamsHandling: "preserve" });
		}
	}

	changePassword() {
		if (!this.passwordChangeForm.valid) {
			return;
		}
		this.processingRequest = true;
		this._authService.changePassword(this.passwordChangeForm.get("currentPassword")!.value!, this.passwordChangeForm.get("newPassword")!.value!)
			.pipe(
				finalize(() => {
					this.processingRequest = false;
				})
			)
			.subscribe({
				next: (v) => {
					this.passwordChanged = true;
				}
			})
	}
}
